import {
  useQuery,
  QueryKey,
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
} from "react-query";

import useAppContextRole from "../../app-context/useAppContextRole";

import useIsAuthorized from "./useIsAuthorized";

export function useAuthorizedQuery<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(
  queryKey: TQueryKey,
  queryFn: QueryFunction<TQueryFnData, TQueryKey>,
  options?: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TData, TError> {
  const isAuthorized = useIsAuthorized();
  const [role] = useAppContextRole();
  const isReady = !!role && isAuthorized;

  return useQuery(queryKey, queryFn, {
    ...options,
    enabled:
      options?.enabled !== undefined ? options.enabled && isReady : isReady,
  });
}

export default useAuthorizedQuery;
